$(document).ready(function(){
  calculateTheHeight();
  resizeSlick();
  curentPopup();
  activeTab();
  $(window).resize(function() {
    calculateTheHeight();
  });
  // --------------------------------------------
  $('.col-sellers .content-block').flickity({
    prevNextButtons: true,
    pageDots: false,
    wrapAround: false,
    contain: true,
    cellAlign: "center",
    dragThreshold: 8,
    groupCells: true,
  });
 
  $('.Product__SlideshowNavScrolle').slick({
    vertical: true,
    slidesToShow:2,
    verticalSwiping: true,
  });

  //   -----------------------Header search----------------------
  $('.search-color').click(function(){
    $('.Header__Wrapper').toggleClass('ac-search');
    $('#collection-filter-drawer').attr('aria-hidden', 'true');
  });
  $('.Search__Close.Link').click(function(){
    $('.Header__Wrapper').removeClass('ac-search');
  });


});
// -----------------------Page Contact slide-------------
$(window).resize(function() {
  setTimeout(function(){ 
    resizeSlick();
  });
});
function resizeSlick(){
  $('.link_desktop').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    variableWidth: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


$.fn.hasAttr = function(name) {  
  return this.attr(name) !== undefined;
};

$(document).ready(function() {
  $('.SizeSwatch').click(function(){
    setTimeout(function(){ 
      var $dataAction = $('.ProductForm__AddToCart').attr('disabled');
      var $dataAdd = $('.ntc ');
      var $dataClass = $('.Product__Info');
      if($dataAction == 'disabled') {
        $dataAdd.addClass('data-action');
        $dataClass.addClass('data-active');
      }else{
        $dataAdd.removeClass('data-action');
        $dataClass.removeClass('data-active');
      }
      ntcHiden();
    }, 100);

  });
  ntcHiden();

  // ----------------------------------------------------
  $('.Product__SlideshowNavArrow').click(function(){
    slideActive();
  });
  $('.Product__SlideshowNavScroller .Product__SlideshowNavImage').click(function(){
    slideActive();
  });
  $('.flickity-page-dots .dot').click(function(){
    slideActive();
  });
});

$(document).click(function(event) { 
  $target = $(event.target);
  if(!$target.closest('.ntc-hid').length && 
     $('.ntc-hid').is(":visible")) {
  }        
});

//   -----------------------Product hidden sold out--------------
function ntcHiden(){
  $('.data-action').click(function(){
    $('.ntc-hid').addClass('hiden-atc');
    $('.bg').addClass('display-bg');
    $('body').addClass('sticky-header');
  });
  $('.bg').click(function(){
    $('.bg').removeClass('display-bg');
    $('.ntc-hid').removeClass('hiden-atc');
    $('body').removeClass('sticky-header');
  });
}
//   -----------------------Product active Slide image--------------------
function slideActive(){
  setTimeout(function(){  
    var $heightImage = $('.Image--fadeIn').height();
    $('.Product__SlideshowNavScroller .Product__SlideshowNavImage').each(function(){
      var $checkClass = $(this).hasClass('is-selected');
      var $alert = $(this).attr('data-position');
      if($checkClass){
        $('.Product__SlideshowNavScroller').addClass($alert);
      }else{
        $('.Product__SlideshowNavScroller').removeClass($alert);
      }
    });
    $('.is-1').css("margin-top",+ 0 + 'px');
    $('.is-2').css("margin-top",+ -$heightImage/2-25 + 'px');
    $('.is-3').css("margin-top",+ -$heightImage-50 + 'px');
    $('.is-4').css("margin-top",+ -$heightImage*1.5-75 + 'px');
    $('.is-5').css("margin-top",+ -$heightImage*2-100 + 'px');
    $('.is-6').css("margin-top",+ -$heightImage*2.5-125 + 'px');
    $('.is-7').css("margin-top",+ -$heightImage*3-150 + 'px');
    $('.is-8').css("margin-top",+ -$heightImage*3.5-175 + 'px');
  });
}

function calculateTheHeight(){
  var $win = $(window).width();
  var $heightImage = $('.Image--fadeIn').height();
  $('.Product__SlideshowNav--thumbnails').css("height",+ $heightImage + 'px');
  if($win > 768){
    $('.Product__SlideshowMobileNav').css("height",+ $heightImage + 'px');
  }
}
// ----------------Collection scroll-------------------
$(document).ready(function(){
  var $window = $(window);
  $window.on('scroll', function() {
    var currentScroll = $window.scrollTop();
    if(currentScroll > 50){
      $('.template-collection #collection-sort-popover').addClass('addposition');
    }else{
      $('.template-collection #collection-sort-popover').remove('addposition');
    }
  });
  $('.collection-filter-drawer .Link--primary').click(function(){
    $('.ButtonGroup__Item--expand[data-action="apply-tags"]').trigger('click');
  });
  $('.HorizontalList__Item-custom .Link--primary').click(function(){
    $('body').removeClass('ac-fillter');
  });
});
//----------------------Collection filter ------------------
function curentPopup(){
  $('.items-filter').click(function(){
    $(this).addClass('ac-fil');
    $('.items-filter').removeClass('ac-fil');
  });

  $('.CollectionMain .Collapsible__Button').click(function(){
    $(this).toggleClass('ac-togle');
    $(this).next().slideToggle(300);
  });

  $('.curen-cus .SelectButton').click(function(){
    $('.curen-cus .Popover--noWrap').attr('aria-hidden', 'false');
    $('.PageOverlay').css({"visibility": "visible", "opacity": "0.5"});
    $('#collection-filter-drawer').attr('aria-hidden', 'true');

  });
  $('.curen-cus .Popover__Close').click(function(){
    $('.curen-cus .Popover--noWrap').attr('aria-hidden', 'true');
    $('.PageOverlay').css({"visibility": "hidden", "opacity": "0"});
  });
  $('.PageOverlay').click(function(){
    $(this).css({"visibility": "hidden", "opacity": "0"});
    $('.curen-cus .Popover--noWrap').attr('aria-hidden', 'true');
    $('body').removeClass('ac-fillter');
  });
  $('.curen-cus .heading-filter').click(function(){
    $('.hidden-lap-and-up').trigger('click');
    $('#collection-filter-drawer').attr('aria-hidden', 'false');

    $('body').addClass('ac-fillter');
  });


  $('.collap-cus .Collapsible__Button').click(function(){
    var $collap_pos = $(this).attr('data-position');
    $('.collap-cus .Collapsible__Button').removeClass('ac-icon');
    $(this).toggleClass('ac-icon');

    $(".Drawer__Main #collapsible").each(function(){
      var $x = $(this).attr('data-position');
      if($collap_pos == $x){
        $(this).trigger('click');
      }
    });

  });
}
// ---------------------- page Customer care----------------
function activeTab(){
  $('.flex-page .Linklist li a:not(:first)').addClass('in-active');
  $('.flex-page .Linklist li a').click(function(){
    var t = $(this).attr('id');
    if($(this).hasClass('in-active')){ //this is the start of our condition 
      $('.flex-page .Linklist li a').addClass('in-active');           
      $(this).removeClass('in-active');
      $('.content').hide();
      $('#'+ t + 'C').fadeIn('slow');
    }
    $('.flex-page .Linklist li a').removeClass('ac-bor');
    $(this).addClass('ac-bor');   
  });
}





















// -----------------------------------Sizing guide product-----------------
$(document).ready(function(){

  $('.chart-btn').click(function(){
    $('body').addClass('open-size');
  });
  $('.svg').click(function(){
    $('body').removeClass('open-size');
  });
  $('.sizing-bg').click(function(){
    $('body').removeClass('open-size');
  });

  $('.sizing-label-top').click(function(){
    $('.sizing-text').removeClass('ac-size');
  });
  $('.sizing-label-bot').click(function(){
    $('.sizing-text').addClass('ac-size');
  });

  //   $('#click-messe').click(function(){
  //   	 $('.chat-app button').trigger('click');
  //   });
  $('#click-messe').click(function(){
    $('#shopify-chat iframe').attr('isopen', 'true');
  });

  $('.label-region').click(function () {
    var x = $(this).text();
    if(x == 'US'){
      $('.sizing-size-1').text('0');
      $('.sizing-size-2').text('2');
      $('.sizing-size-3').text('4');
      $('.sizing-size-4').text('6');
      $('.sizing-size-5').text('8');
      $('.sizing-size-6').text('10');
      $('.size-number').attr('value', 'US');

    }else if(x == 'UK'){
      $('.sizing-size-1').text('32');
      $('.sizing-size-2').text('34');
      $('.sizing-size-3').text('36');
      $('.sizing-size-4').text('38');
      $('.sizing-size-5').text('40');
      $('.sizing-size-6').text('42');
      $('.size-number').attr('value', 'UK');
    }else if(x == 'EU'){
      $('.sizing-size-1').text('4');
      $('.sizing-size-2').text('6');
      $('.sizing-size-3').text('8');
      $('.sizing-size-4').text('10');
      $('.sizing-size-5').text('12');
      $('.sizing-size-5').text('14');
      $('.size-number').attr('value', 'EU');
    } else{
      $('.sizing-size-1').text('4');
      $('.sizing-size-2').text('6');
      $('.sizing-size-3').text('8');
      $('.sizing-size-4').text('10');
      $('.sizing-size-5').text('12');
      $('.sizing-size-5').text('14');
      $('.size-number').attr('value', 'AUS');
    }
  });

  $('.sizing-size-1').click(function () {
    $('.output-title h3').text('XXS');
    $('.bust').text('81-86 cm');
    $('.underbust').text('70-75 cm');
    $('.waist').text('63-66 cm');
    $('.hip').text('89-92 cm');
    $('.lower-waist').text('79-82 cm');
  });
  $('.sizing-size-2').click(function () {
    $('.output-title h3').text('XS');
    $('.bust').text('87-92 cm');
    $('.underbust').text('71-86 cm');
    $('.waist').text('67-70 cm');
    $('.hip').text('93-96 cm');
    $('.lower-waist').text('80-83 cm');
  });
  $('.sizing-size-3').click(function () {
    $('.output-title h3').text('S');
    $('.bust').text('93-98 cm');
    $('.underbust').text('83-86 cm');
    $('.waist').text('71-74 cm');
    $('.hip').text('97-100 cm');
    $('.lower-waist').text('87-90 cm');
  });
  $('.sizing-size-4').click(function () {
    $('.output-title h3').text('M');
    $('.bust').text('99-104 cm');
    $('.underbust').text('88-93 cm');
    $('.waist').text('75-78 cm');
    $('.hip').text('101-104 cm');
    $('.lower-waist').text('91-94 cm');
  });
  $('.sizing-size-5').click(function () {
    $('.output-title h3').text('L');
    $('.bust').text('105-110 cm');
    $('.underbust').text('94-102 cm');
    $('.waist').text('79-82 cm');
    $('.hip').text('105-108 cm');
    $('.lower-waist').text('95-98 cm');
  });
  $('.sizing-size-6').click(function () {
    $('.output-title h3').text('XL');
    $('.bust').text('108-112 cm');
    $('.underbust').text('103-108 cm');
    $('.waist').text('83-86 cm');
    $('.hip').text('109-112 cm');
    $('.lower-waist').text('99-102 cm');
  });
});